import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux' 
import { Navigate } from 'react-router-dom'
import { withRouter } from 'globals/utils'
import { Segment, Button } from 'semantic-ui-react'
import Loaded from 'components/loaded'
import { getAdvisorSettings } from 'data/advisor/settings/action'
import { getChangelog } from 'data/messages/action'
import { getRollover } from 'data/bmc/rollover/action'

import logo from 'img/logo.png'
import './style.css' 

class WhatsNewPage extends React.Component {
  constructor(props) {
    super(props) 
    this.state = {
      errors: {},
      loading: false,
      done: false,
    }
  }

  componentDidMount() {
    if (!this.props.changelog ) {
      this.setState({loading: true})
      Promise.all([this.props.getChangelog(), this.props.getRollover()]).then(()=>{
        this.setState({done: true})}
      ).catch(err => {
        console.log('error loading:', err)
      })
    } else if (this.props.changelog.length === 0) {
      if (!!this.props.events && this.props.events.length === 0)  {
        this.setState({skip: true})
      } else {  
        this.setState({roll: true})
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps.changelog !== this.props.changelog) || (prevProps.events !== this.props.events || prevState.done !== this.state.done)) {
      if (!!this.props.changelog && this.props.changelog.length > 0) {     
        this.setState({loading: false})
      } else if (!!this.props.events && this.props.events.length > 0) {
        this.props.navigate("/bmc/rollover")
      } else if (this.state.done) {
        if (this.props.status === 'advisor') { 
          this.props.getAdvisorSettings().then(() => {this.props.navigate('/advisor')})     
        } else if (process.env.REACT_APP_TYPE==='NAV') {
          this.props.navigate('/home')
        } else {
          this.props.navigate('/bmc/reports')
        }
      }
    }
  }

  onContinue = () => {
    const { events } = this.props
    if (events && events.length!==0) {
      this.props.navigate("/bmc/rollover")
    } else if (process.env.REACT_APP_TYPE==='NAV') {
      this.props.navigate('/home')
    } else {
      this.props.navigate('/bmc/reports')
    }
  }
  
  createMarkup = (data) => { return {__html: data} }

  formatChangeLog(item) {
    let {changedate, changes} = item
    return ('<div><h2>'+new Date(changedate).toDateString()+'</h2>'+changes+'</div>')
  }

  render() { 
    const { loading, roll, skip} = this.state  
    const { changelog } = this.props  
    if (roll) return <Navigate to='/bmc/rollover' />
    if (skip) return <Navigate to='/home' />
    return (
      <Loaded loading={loading}>
        {!loading && <Segment className="ui container changelog">
          <img id='rollLogo' src={logo} alt='logo'/>
          <h1 className='center green'>We have made some changes</h1>
          <h3 className='grey'>Below you will find the changes that have been implemented since you last logged in.  Take this time to look over the new features and changes before moving on to the application.</h3>
          <h2 className='green'>What's New!</h2>
          {
            changelog && changelog.length>0 && changelog.map((item,i) => (
              <div className='changelogholder' key={i} dangerouslySetInnerHTML={this.createMarkup(this.formatChangeLog(item))} />
            ))
          }
          <div className="changeButton"><Button className='button_green' icon='arrow right' content='Continue' onClick={this.onContinue} /></div>
        </Segment>}
      </Loaded>
    )
  }
}

function mapStateToProps(state) {
  return {
    lastLogin: state.auth.lastLogin,
    status: state.auth.status,
    changelog: state.shared_data.messages.changelog,
    events: state.shared_data.bmc.rollover
  }
}

export default withRouter(connect(mapStateToProps, { getAdvisorSettings, getChangelog, getRollover })(WhatsNewPage));